const projectData = [
  {
    projectName: "Snapnmix",
    projectBody:
      "A cocktail recipe finder web app that queries databases for popular recipes based upon user-uploaded images of ingredients.",
    projectRole:
      "Built and Designed Sign In, Scan, Account Pages. Implemented Google's Cloud Vision AI on backend.",
    projectStack: [
      "React",
      "Express.JS",
      "Node.JS",
      "MongoDB",
      "Bootstrap",
      "CSS",
      "Javascript",
    ],
    projectLinks: 2,
    projectGithub: "https://github.com/JaydanZ/Snap-N-Mix",
    projectDemo: "https://snapnmix.net/",
    mockup: "snapnmix",
  },
  {
    projectName: "Synosong",
    projectBody:
      "A full stack application to query songs from Spotify’s API using synonyms based on randomly generated or user-inputted words",
    projectRole:
      "Developed REST API's to handle user authentication with Next Auth, Implemented Spotify's API on Next.js backend",
    projectStack: [
      "React",
      "Next.js",
      "Next Auth",
      "Typescript",
      "Redux",
      "SCSS",
    ],
    projectLinks: 2,
    projectGithub: "https://github.com/JaydanZ/SynoSong",
    projectDemo: "https://synosong.vercel.app/",
    mockup: "synosong",
  },
  {
    projectName: "Live Lift",
    projectBody:
      "A bodybuilding strength training web application for storing exercises for user created workout routines. Developed for MegaHackathon 2022 to promote good health and well-being.",
    projectRole:
      "Designed and Implemented UI mockups. Connected components to Firebase DB.",
    projectStack: ["React", "Firebase", "CSS", "Javascript"],
    projectLinks: 1,
    projectGithub: "https://github.com/JaydanZ/Live-Lift",
    projectDemo: "",
    mockup: "livelift",
  },
  {
    projectName: "FDMS",
    projectBody:
      "An aircraft metadata logging system with dashboards to log and view aircraft top speed, weight, tail number, etc. Composed of a C# Server and a WPF desktop application.",
    projectRole:
      "Built TCP/IP Server to handle data transmission. Developed front-end and back-end of client application using C# and XML.",
    projectStack: ["WPF", "C#", "MySQL", "XML"],
    projectLinks: 1,
    projectGithub:
      "https://github.com/JaydanZ/Flight-Data-Management-System--FDMS-",
    projectDemo: "",
    mockup: "fdms",
  },
];

export default projectData;
